/*!
  =========================================================
  * Muse Ant Design Dashboard - v1.0.0
  =========================================================
  * Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
  * Copyright 2021 Creative Tim (https://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
  * Coded by Creative Tim
  =========================================================
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";
import { Menu } from "antd";
import { NavLink } from "react-router-dom";
import { TeamOutlined } from "@ant-design/icons";
import logo from "../../assets/images/logo.png";

function Sidenav({ color }) {
  const dashboard = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z"
        fill={color}
      ></path>
      <path
        d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z"
        fill={color}
      ></path>
      <path
        d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const userManagement = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      key={1}
    >
      <path
        d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-3.866 0-7 3.134-7 7h14c0-3.866-3.134-7-7-7z"
        fill={color}
      ></path>
    </svg>,
  ];

  const projectManagement = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      key={2}
    >
      <path
        d="M3 3h18v2h-18v-2zm0 4h18v2h-18v-2zm0 4h18v2h-18v-2zm0 4h18v2h-18v-2zm0 4h18v2h-18v-2z"
        fill={color}
      ></path>
    </svg>,
  ];

  const logManagement = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      key={3}
    >
      <path
        d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
        fill={color}
      ></path>
      <path
        d="M13 7h-2v6h6v-2h-4z"
        fill={color}
      ></path>
    </svg>,
  ];

  return (
    <>
      <div className="brand">
        <img src={logo} alt="" />
        <span>IAM Dashboard</span>
      </div>
      <hr />
      <Menu theme="light" mode="inline">
        <Menu.Item key="1">
          <NavLink to="/dashboard">
            <span className="icon" style={{ background: color }}>
              {dashboard}
            </span>
            <span className="label">Dashboard</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="2">
          <NavLink to="/usermanagement">
            <span className="icon" style={{ background: color }}>
              {userManagement}
            </span>
            <span className="label">User Management</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="3">
          <NavLink to="/projectmanagement">
            <span className="icon" style={{ background: color }}>
              {projectManagement}
            </span>
            <span className="label">Project Management</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="4">
          <NavLink to="/logmanagement">
            <span className="icon" style={{ background: color }}>
              {logManagement}
            </span>
            <span className="label">Log Management</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="5">
          <NavLink to="/systemusermanagement">
            <span className="icon" style={{ background: color, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <TeamOutlined style={{ fontSize: 20, color: "#1890ff", lineHeight: "20px" }} />
            </span>
            <span className="label">System User Management</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="6">
          <NavLink to="/qrcode">
            <span className="icon" style={{ background: color }}>
              <TeamOutlined />
            </span>
            <span className="label">QR Generator</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="7">
          <NavLink to="/sessionmanagement">
            <span className="icon" style={{ background: color }}>
              <TeamOutlined />
            </span>
            <span className="label">Session Management</span>
          </NavLink>
        </Menu.Item>
      </Menu>
    </>
  );
}

export default Sidenav;
